import { formatLocalDateTime } from './analysisTabDateTime';

export function getRelativeTimeValue(selectedTimeRange: string): number {
  switch (selectedTimeRange) {
    case 'Last 1 hour':
      return 0;
    case 'Last 2 hours':
      return 1;
    case 'Last 4 hours':
      return 2;
    case 'Last 8 hours':
      return 3;
    case 'Last 24 hours':
      return 4;
    case 'Last 7 days':
      return 5;
    default:
      return 6;
  }
}

export interface AnalysisDateRangeState {
  selectedTimeRange: string;
  startDate: Date | null;
  endDate: Date | null;
  appliedStartDate: Date | null;
  appliedEndDate: Date | null;
}

export function getAnalysisDateRange(state: AnalysisDateRangeState): { startTime: string; endTime: string } {
  const { selectedTimeRange, startDate, endDate, appliedStartDate, appliedEndDate } = state;
  const now = new Date();
  let startMs: number;
  const endMs = now.getTime();

  if (
    selectedTimeRange === 'Custom date range' &&
    (startDate || appliedStartDate) &&
    (endDate || appliedEndDate)
  ) {
    const effectiveStartDate = startDate || appliedStartDate!;
    const effectiveEndDate = endDate || appliedEndDate!;

    return {
      startTime: formatLocalDateTime(effectiveStartDate),
      endTime: formatLocalDateTime(effectiveEndDate),
    };
  }

  switch (selectedTimeRange) {
    case 'Last 1 hour':
      startMs = endMs - 1 * 60 * 60 * 1000;
      break;
    case 'Last 2 hours':
      startMs = endMs - 2 * 60 * 60 * 1000;
      break;
    case 'Last 4 hours':
      startMs = endMs - 4 * 60 * 60 * 1000;
      break;
    case 'Last 8 hours':
      startMs = endMs - 8 * 60 * 60 * 1000;
      break;
    case 'Last 24 hours':
      startMs = endMs - 24 * 60 * 60 * 1000;
      break;
    case 'Last 7 days':
      startMs = endMs - 7 * 24 * 60 * 60 * 1000;
      break;
    default:
      startMs = endMs - 1 * 60 * 60 * 1000;
  }

  return {
    startTime: formatLocalDateTime(new Date(startMs)),
    endTime: formatLocalDateTime(new Date(endMs)),
  };
}
